import { schema } from "normalizr";

const CustomerCompanySchema = new schema.Entity("customerCompanies", {

}, {
  idAttribute: "customerCompanyNo"
});
const CustomerCompanyArraySchema = new schema.Array(CustomerCompanySchema);

export { CustomerCompanySchema, CustomerCompanyArraySchema };